import React from 'react';
import { Label } from './styled';

const LabelForm = ({ text }) => {
  return <Label>{text}</Label>;
};

export default LabelForm;
